export default __webpack_public_path__ + "static/media/salesforce_service_cloud.fbbe8bbe.png";